import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ExpressInsiderCreditCardLogo: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--express-insider-credit-card-logo')}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M27.5 7v14.5H24V24H4V10h4V7h19.5zm-5.039 9H5.538v6.552h16.924L22.46 16zM26 8.5H9.5V10H24v10h2V8.5zm-3.538 2.948H5.538V14h16.923v-2.552z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default ExpressInsiderCreditCardLogo;
